/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateJobConfigDto
 */
export interface CreateUpdateJobConfigDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateJobConfigDto
     */
    type: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateJobConfigDto
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateJobConfigDto
     */
    crone: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateJobConfigDto
     */
    queueName: string;
}

/**
 * Check if a given object implements the CreateUpdateJobConfigDto interface.
 */
export function instanceOfCreateUpdateJobConfigDto(value: object): value is CreateUpdateJobConfigDto {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('crone' in value) || value['crone'] === undefined) return false;
    if (!('queueName' in value) || value['queueName'] === undefined) return false;
    return true;
}

export function CreateUpdateJobConfigDtoFromJSON(json: any): CreateUpdateJobConfigDto {
    return CreateUpdateJobConfigDtoFromJSONTyped(json, false);
}

export function CreateUpdateJobConfigDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateJobConfigDto {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'active': json['active'],
        'crone': json['crone'],
        'queueName': json['queueName'],
    };
}

export function CreateUpdateJobConfigDtoToJSON(value?: CreateUpdateJobConfigDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'type': value['type'],
        'active': value['active'],
        'crone': value['crone'],
        'queueName': value['queueName'],
    };
}

